import type { LucideProps } from 'lucide-react'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import TabIconButton from 'src/features/navigation/components/pro-app-frame-tab-icon-button'
import { HelpCenterIcon } from 'src/features/navigation/icons/help-center-icon'
import { Iconmark } from 'src/shared/components/icons/logos/iconmark'
import SupportDialogV2 from 'src/shared/features/support/components/support-dialog-v2'

import ULProgressBar from './ul-progressbar'

interface UploadLeadsNavbarProps {
  // The link to exit the flow.
  exitLink: string
}

/** Note: Similar to business create navbar. Can be reusable */
const UploadLeadsNavbar = ({ exitLink }: UploadLeadsNavbarProps) => {
  const [isSupportDialogOpen, setIsSupportDialogOpen] = useState(false)

  return (
    <div className="flex size-full flex-col items-center justify-between bg-primary px-4 py-5 text-white">
      <Link to={exitLink}>
        <Iconmark size={36} />
      </Link>
      <ULProgressBar />
      <TabIconButton
        key="help-center"
        icon={(props: LucideProps) => <HelpCenterIcon size={22} {...props} />}
        onClick={() => setIsSupportDialogOpen(true)}
        isActive={false}
      />
      <SupportDialogV2 open={isSupportDialogOpen} setOpen={setIsSupportDialogOpen} />
    </div>
  )
}

export default UploadLeadsNavbar
